/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AuthDto {
  /** @example "admin" */
  username: string;
  /** @example "password" */
  password: string;
}

export interface TokenDto {
  access_token: string;
}

export interface AdminUserBaseDto {
  /** @example 1 */
  id: number;
  /** @example "ivan.onuchin@dupontregistrygroup.com" */
  email: string;
  /** @example "Ivan" */
  firstName: string;
  /** @example "Onuchin" */
  lastName: string;
  /** @example "dcsdf-sdfsdfsd-sdfsdfsd" */
  userId: string;
  /** @example 15045 */
  zipCode: number;
  /** @example "TX" */
  state: string;
  /** @example "0123456789" */
  phone: string;
  /** @example 5 */
  buyOffersCount: number;
  /** @example 7 */
  sellOffersCount: number;
  /** @example 2 */
  dealsCount: number;
}

export interface AdminDealDto {
  /** @example "3B7HF16Z8XM506485" */
  vin: string;
  /** @example 100500 */
  price: number;
  /** @example "BMW i3" */
  title: string;
  /** @example 1050 */
  mileage: number;
  /** @example "DE2255" */
  stockNumber: string;
  /** @example "https://www.mycar.com/besti3.jsp" */
  primaryImage: string;
  /** @example 1998 */
  year: number;
  /** @example "BMW" */
  make: string;
  /** @example "i3" */
  model: string;
  /** @format date-time */
  endAt?: string;
  /** @example "active" */
  status: "active" | "expired" | "accepted" | "cancelled" | "error" | "sold";
  /** @format date-time */
  createdAt?: string;
  /** @example 10 */
  id: number;
  /** @example "myev" */
  client: string;
  /** @example 10 */
  offersCount: number;
  owner: AdminUserBaseDto;
  transactionId: string;
  /** @example false */
  deleted: boolean;
}

export interface AdminDealCollectionDto {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  data: AdminDealDto[];
}

export interface AdminEditDialDto {
  /** @example "3B7HF16Z8XM506485" */
  vin: string;
  /** @example 100500 */
  price: number;
  /** @example "BMW i3" */
  title: string;
  /** @example 1050 */
  mileage: number;
  /** @example "DE2255" */
  stockNumber: string;
  /** @example "https://www.mycar.com/besti3.jsp" */
  primaryImage: string;
  /** @example 1998 */
  year: number;
  /** @example "BMW" */
  make: string;
  /** @example "i3" */
  model: string;
  /** @format date-time */
  endAt?: string;
  /** @example "active" */
  status: "active" | "expired" | "accepted" | "cancelled" | "error" | "sold";
  /** @format date-time */
  createdAt?: string;
}

export interface AdminTransactionDto {
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @example "http://drivecarame.com/some-transactions" */
  buyerLink?: string;
  /** @example "http://drivecarame.com/some-transactions" */
  sellerLink?: string;
}

export interface AdminOfferDto {
  /** @example 99 */
  id?: number;
  /** @example "3B7HF16Z8XM506485" */
  vin?: string;
  /** @example "DR0587" */
  stockNumber?: string;
  /** @example "BMW i3" */
  title: string;
  buyer: AdminUserBaseDto;
  seller: AdminUserBaseDto;
  ended: boolean;
  /** @format date-time */
  endAt?: string;
  /** @format date-time */
  createdAt?: string;
  /** @example "offer" */
  status:
    | "offer"
    | "counteroffer"
    | "retract"
    | "accept"
    | "decline"
    | "buynow"
    | "empty"
    | "expired"
    | "closed"
    | "accept-counteroffer"
    | "decline-counteroffer"
    | "conversation";
  /**
   * Virtual field. Can be offer or counteroffer
   * @example "offer"
   */
  type: string;
  /** @example 100500 */
  price?: number;
  /** @example "https://myev.com/best-car/3B7HF16Z8XM506485" */
  url: string;
  /** @default null */
  transaction?: AdminTransactionDto;
}

export interface AdminOfferCollectionDto {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  data: AdminOfferDto[];
}

export interface AdminEditOfferDto {
  /** @example "DR0587" */
  stockNumber: string;
  /** @example "https://myev.com/best-car/3B7HF16Z8XM506485" */
  url: string;
  /** @example "counteroffer" */
  status:
    | "offer"
    | "counteroffer"
    | "retract"
    | "accept"
    | "decline"
    | "buynow"
    | "empty"
    | "expired"
    | "closed"
    | "accept-counteroffer"
    | "decline-counteroffer"
    | "conversation";
  /** @example false */
  ended: boolean;
  /**
   * endedAt
   * @example "2023-01-01"
   */
  endAt: string;
  /** @example 100500 */
  price?: number;
}

export interface AdminMessageDto {
  id?: number;
  price?: number;
  message?: string;
  /** @format date-time */
  createdAt?: string;
  /** @example "offer" */
  type:
    | "offer"
    | "counteroffer"
    | "retract"
    | "accept"
    | "decline"
    | "buynow"
    | "empty"
    | "expired"
    | "closed"
    | "accept-counteroffer"
    | "decline-counteroffer"
    | "conversation";
  creator: AdminUserBaseDto;
}

export interface AdminMessageCollectionDto {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  data: AdminMessageDto[];
}

export interface AdminUserCollectionDto {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  data: AdminUserBaseDto[];
}

export interface AdminEditMessageDto {
  priceOffer?: number;
  message?: string;
  /** @example "offer" */
  type:
    | "offer"
    | "counteroffer"
    | "retract"
    | "accept"
    | "decline"
    | "buynow"
    | "empty"
    | "expired"
    | "closed"
    | "accept-counteroffer"
    | "decline-counteroffer"
    | "conversation";
}

export interface OfferDealDto {
  /** @example "BMW i3" */
  title: string;
  /** @example "https://www.mycar.com/besti3.jsp" */
  primaryImage: string;
  /** @format date-time */
  endAt?: string;
  /** @example "DE2255" */
  stockNumber: string;
}

export interface OfferMessageDto {
  /** @example 10 */
  id: number;
  /** @example 100500 */
  priceOffer: number;
  /** @example "I want to buy this car" */
  message: string;
  /**
   * @format date-time
   * @example "2025-02-12T14:06:23.282Z"
   */
  createdAt: string;
  /** @example "offer" */
  type:
    | "offer"
    | "counteroffer"
    | "retract"
    | "accept"
    | "decline"
    | "buynow"
    | "empty"
    | "expired"
    | "closed"
    | "accept-counteroffer"
    | "decline-counteroffer"
    | "conversation";
  /** @example "seller" */
  from: "seller" | "buyer";
}

export interface OfferDto {
  /** @example "DR0587" */
  stockNumber: string;
  /** @example "https://myev.com/best-car/3B7HF16Z8XM506485" */
  url: string;
  /** @example "offer" */
  status:
    | "offer"
    | "counteroffer"
    | "retract"
    | "accept"
    | "decline"
    | "buynow"
    | "empty"
    | "expired"
    | "closed"
    | "accept-counteroffer"
    | "decline-counteroffer"
    | "conversation";
  ended: boolean;
  /** @format date-time */
  endedAt?: string;
  /** @format date-time */
  createdAt?: string;
  /** @example 100500 */
  price?: number;
  deal?: OfferDealDto;
  messages: OfferMessageDto[];
  /** @example 10 */
  id: number;
}

export interface OfferCollectionDto {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  data: OfferDto[];
}

export interface CreateOfferDto {
  /** @example "DR0587" */
  stockNumber: string;
  /** @example "https://myev.com/best-car/3B7HF16Z8XM506485" */
  url: string;
  /** @example "offer" */
  status:
    | "offer"
    | "counteroffer"
    | "retract"
    | "accept"
    | "decline"
    | "buynow"
    | "empty"
    | "expired"
    | "closed"
    | "accept-counteroffer"
    | "decline-counteroffer"
    | "conversation";
  ended: boolean;
  /** @format date-time */
  endedAt?: string;
  /** @format date-time */
  createdAt?: string;
  /** @example 100500 */
  price?: number;
  deal?: OfferDealDto;
  messages: OfferMessageDto[];
}

export interface OfferEligibleDto {
  /** @example true */
  eligible: boolean;
  /** @example 5 */
  availableAttemptsCount: number;
  offer: OfferDto;
  conversation: OfferDto;
  /** @example "active" */
  dealStatus: "active" | "expired" | "accepted" | "cancelled" | "error" | "sold" | null;
}

export interface CreateDealDto {
  /** @example "3B7HF16Z8XM506485" */
  vin: string;
  /** @example 100500 */
  price: number;
  /** @example "BMW i3" */
  title: string;
  /** @example 1050 */
  mileage: number;
  /** @example "DE2255" */
  stockNumber: string;
  /** @example "https://www.mycar.com/besti3.jsp" */
  primaryImage: string;
  /** @example 1998 */
  year: number;
  /** @example "BMW" */
  make: string;
  /** @example "i3" */
  model: string;
  /** @format date-time */
  endAt?: string;
  /** @example "active" */
  status: "active" | "expired" | "accepted" | "cancelled" | "error" | "sold";
  /** @format date-time */
  createdAt?: string;
}

export interface DealDto {
  /** @example "3B7HF16Z8XM506485" */
  vin: string;
  /** @example 100500 */
  price: number;
  /** @example "BMW i3" */
  title: string;
  /** @example 1050 */
  mileage: number;
  /** @example "DE2255" */
  stockNumber: string;
  /** @example "https://www.mycar.com/besti3.jsp" */
  primaryImage: string;
  /** @example 1998 */
  year: number;
  /** @example "BMW" */
  make: string;
  /** @example "i3" */
  model: string;
  /** @format date-time */
  endAt?: string;
  /** @example "active" */
  status: "active" | "expired" | "accepted" | "cancelled" | "error" | "sold";
  /** @format date-time */
  createdAt?: string;
  /** @example 10 */
  id: number;
}

export interface ValidationErrorDto {
  /** @example "["vin should not be empty"]" */
  message: string[];
  /** @example "Bad Request" */
  error: string;
  /** @example 400 */
  statusCode: number;
}

export interface DealCollectionDto {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  data: DealDto[];
}

export interface UpdateDealDto {
  /** @example 100500 */
  price: number;
  /** @example "BMW i3" */
  title: string;
  /** @example 1050 */
  mileage: number;
  /** @example "https://www.mycar.com/besti3.jsp" */
  primaryImage: string;
  /** @example 1998 */
  year: number;
  /** @example "BMW" */
  make: string;
  /** @example "i3" */
  model: string;
  /** @example "cancelled" */
  status: "cancelled";
}

export interface MessageWebhook {
  /** @example "buyer@test.com" */
  creator: string;
  /** @example "Hello" */
  message: string;
}

export interface OfferWebhook {
  /** @example "offer.created" */
  type:
    | "offer.created"
    | "offer.counter_offered"
    | "offer.retracted"
    | "offer.accepted"
    | "offer.declined"
    | "offer.buy_now"
    | "offer.expired"
    | "offer.closed"
    | "offer.counter_offer_accepted"
    | "offer.counter_offer_declined"
    | "offer.completed"
    | "offer.failed"
    | "offer.conversation";
  /** @example "DR0587" */
  stockNumber: string;
  /** @example "https://myev.com/best-car/3B7HF16Z8XM506485" */
  url: string;
  /** @example "seller@myev.com" */
  seller: string;
  /** @example "buyer@myev.com" */
  buyer: string;
  /** @example "https://myev.com/dr-chat/auth?redirectUrl=https://test-back.chat.dupontregistry.com/api/v1/transactions/7rdhY8HBc4b4btQzLZz5hH/visit/?client=myev" */
  buyerLink: string;
  /** @example "https://myev.com/dr-chat/auth?redirectUrl=https://test-back.chat.dupontregistry.com/api/v1/transactions/7rdhY8HBc4b4btQzLZz5hH/visit/?client=myev" */
  sellerLink: string;
  /** @example 100000 */
  price: number;
  /** @example "j7QG7moejzRjvAs5H6vxNK" */
  transactionId: string;
  message: MessageWebhook;
}

export interface CaramelWebhookDto {
  /** @example "deal" */
  type: "deal" | "offer" | "transaction";
  /** @example "created" */
  event: "created" | "accepted" | "canceled" | "transaction_completed";
  dealId: string;
  /** Users email */
  updatedUserId: string;
  /** buyer or seller */
  updatedUserRole: string;
  /** @example "in_progress" */
  sellerSimpleStatus: "not_started" | "in_progress" | "completed" | "inactive";
  /** @example "in_progress" */
  buyerSimpleStatus: "not_started" | "in_progress" | "completed" | "inactive";
  /**
   * @format date-time
   * @example "2025-02-12T14:06:23.282Z"
   */
  transactionDate: string;
  /** @example "1544" */
  sellerUserId: string;
  /** @example "256" */
  buyerUserId: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title DR Index API
 * @version 0.1
 * @contact
 *
 * DR Index API
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Admin API
     * @name AuthControllerSignIn
     * @request POST:/api/admin/login
     */
    authControllerSignIn: (data: AuthDto, params: RequestParams = {}) =>
      this.request<TokenDto, void>({
        path: `/api/admin/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name DealControllerGetAdminList
     * @request GET:/api/admin/deals
     * @secure
     */
    dealControllerGetAdminList: (
      query?: {
        /**
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * JSON-encoded sort object (e.g., "{\"id\":\"ASC\",\"name\":\"DESC\"}")
         * @example "{"id":"ASC"}"
         */
        sort?: string;
        /**
         * JSON-encoded filters object. Available comparators: eq|neq|gt|gte|lt|lte|like|ilike|in|between|isNull
         * @example "{"price":{"gte":100, lte: 100000},"status":{"eq":"expired"}, "owner.email":"testuser@test.com"}"
         */
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminDealCollectionDto, void>({
        path: `/api/admin/deals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name DealControllerAdminUpdate
     * @request PUT:/api/admin/deals/{id}
     * @secure
     */
    dealControllerAdminUpdate: (id: number, data: AdminEditDialDto, params: RequestParams = {}) =>
      this.request<AdminEditDialDto, void>({
        path: `/api/admin/deals/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name DealControllerAdminDelete
     * @request DELETE:/api/admin/deals/{id}
     * @secure
     */
    dealControllerAdminDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/admin/deals/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name DealControllerAdminGetDealOffers
     * @request GET:/api/admin/deals/{id}/offers
     * @secure
     */
    dealControllerAdminGetDealOffers: (
      id: number,
      query?: {
        /**
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * JSON-encoded sort object (e.g., "{\"id\":\"ASC\",\"name\":\"DESC\"}")
         * @example "{"id":"ASC"}"
         */
        sort?: string;
        /**
         * JSON-encoded filters object. Available comparators: eq|neq|gt|gte|lt|lte|like|ilike|in|between|isNull
         * @example "{"price":{"gte":100, lte: 100000},"status":{"eq":"expired"}, "owner.email":"testuser@test.com"}"
         */
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminOfferCollectionDto, void>({
        path: `/api/admin/deals/${id}/offers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name OfferControllerGetList
     * @request GET:/api/admin/offers
     * @secure
     */
    offerControllerGetList: (
      query?: {
        /**
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * JSON-encoded sort object (e.g., "{\"id\":\"ASC\",\"name\":\"DESC\"}")
         * @example "{"id":"ASC"}"
         */
        sort?: string;
        /**
         * JSON-encoded filters object. Available comparators: eq|neq|gt|gte|lt|lte|like|ilike|in|between|isNull
         * @example "{"price":{"gte":100, lte: 100000},"status":{"eq":"expired"}, "owner.email":"testuser@test.com"}"
         */
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminOfferCollectionDto, void>({
        path: `/api/admin/offers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name OfferControllerAdminUpdate
     * @request PUT:/api/admin/offers/{id}
     * @secure
     */
    offerControllerAdminUpdate: (id: number, data: AdminEditOfferDto, params: RequestParams = {}) =>
      this.request<AdminOfferDto, void>({
        path: `/api/admin/offers/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name OfferControllerGetDealOffers
     * @request GET:/api/admin/offers/{id}/messages
     * @secure
     */
    offerControllerGetDealOffers: (
      id: number,
      query?: {
        /**
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * JSON-encoded sort object (e.g., "{\"id\":\"ASC\",\"name\":\"DESC\"}")
         * @example "{"id":"ASC"}"
         */
        sort?: string;
        /**
         * JSON-encoded filters object. Available comparators: eq|neq|gt|gte|lt|lte|like|ilike|in|between|isNull
         * @example "{"price":{"gte":100, lte: 100000},"status":{"eq":"expired"}, "owner.email":"testuser@test.com"}"
         */
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminMessageCollectionDto, void>({
        path: `/api/admin/offers/${id}/messages`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name UserControllerGetList
     * @request GET:/api/admin/users
     * @secure
     */
    userControllerGetList: (
      query?: {
        /**
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * JSON-encoded sort object (e.g., "{\"id\":\"ASC\",\"name\":\"DESC\"}")
         * @example "{"id":"ASC"}"
         */
        sort?: string;
        /**
         * JSON-encoded filters object. Available comparators: eq|neq|gt|gte|lt|lte|like|ilike|in|between|isNull
         * @example "{"price":{"gte":100, lte: 100000},"status":{"eq":"expired"}, "owner.email":"testuser@test.com"}"
         */
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminUserCollectionDto, void>({
        path: `/api/admin/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name UserControllerGetDeals
     * @request GET:/api/admin/users/{id}/deals
     * @secure
     */
    userControllerGetDeals: (
      id: number,
      query?: {
        /**
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * JSON-encoded sort object (e.g., "{\"id\":\"ASC\",\"name\":\"DESC\"}")
         * @example "{"id":"ASC"}"
         */
        sort?: string;
        /**
         * JSON-encoded filters object. Available comparators: eq|neq|gt|gte|lt|lte|like|ilike|in|between|isNull
         * @example "{"price":{"gte":100, lte: 100000},"status":{"eq":"expired"}, "owner.email":"testuser@test.com"}"
         */
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminDealCollectionDto, void>({
        path: `/api/admin/users/${id}/deals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name UserControllerGetBuyOffers
     * @request GET:/api/admin/users/{id}/buy-offers
     * @secure
     */
    userControllerGetBuyOffers: (
      id: number,
      query?: {
        /**
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * JSON-encoded sort object (e.g., "{\"id\":\"ASC\",\"name\":\"DESC\"}")
         * @example "{"id":"ASC"}"
         */
        sort?: string;
        /**
         * JSON-encoded filters object. Available comparators: eq|neq|gt|gte|lt|lte|like|ilike|in|between|isNull
         * @example "{"price":{"gte":100, lte: 100000},"status":{"eq":"expired"}, "owner.email":"testuser@test.com"}"
         */
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminOfferCollectionDto, void>({
        path: `/api/admin/users/${id}/buy-offers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name UserControllerGetSellOffers
     * @request GET:/api/admin/users/{id}/sell-offers
     * @secure
     */
    userControllerGetSellOffers: (
      id: number,
      query?: {
        /**
         * @default 1
         * @example 1
         */
        page?: number;
        /**
         * @default 20
         * @example 20
         */
        limit?: number;
        /**
         * JSON-encoded sort object (e.g., "{\"id\":\"ASC\",\"name\":\"DESC\"}")
         * @example "{"id":"ASC"}"
         */
        sort?: string;
        /**
         * JSON-encoded filters object. Available comparators: eq|neq|gt|gte|lt|lte|like|ilike|in|between|isNull
         * @example "{"price":{"gte":100, lte: 100000},"status":{"eq":"expired"}, "owner.email":"testuser@test.com"}"
         */
        filters?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AdminOfferCollectionDto, void>({
        path: `/api/admin/users/${id}/sell-offers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin API
     * @name MessageControllerAdminUpdate
     * @request PUT:/api/admin/messages/{id}
     * @secure
     */
    messageControllerAdminUpdate: (id: number, data: AdminEditMessageDto, params: RequestParams = {}) =>
      this.request<AdminMessageDto, void>({
        path: `/api/admin/messages/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buyer API
     * @name OfferControllerGet
     * @request GET:/api/v1/buyer/offers
     * @secure
     */
    offerControllerGet: (
      query?: {
        /** @default 1 */
        page?: number;
        /** @default 20 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<OfferCollectionDto, void>({
        path: `/api/v1/buyer/offers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buyer API
     * @name OfferControllerCreate
     * @request POST:/api/v1/buyer/offers
     * @secure
     */
    offerControllerCreate: (data: CreateOfferDto, params: RequestParams = {}) =>
      this.request<OfferDto, void>({
        path: `/api/v1/buyer/offers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buyer API
     * @name OfferControllerGetOne
     * @request GET:/api/v1/buyer/offers/{stockNumber}
     * @secure
     */
    offerControllerGetOne: (stockNumber: string, params: RequestParams = {}) =>
      this.request<OfferDto, void>({
        path: `/api/v1/buyer/offers/${stockNumber}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buyer API
     * @name OfferControllerGetEligible
     * @request GET:/api/v1/buyer/offers/{stockNumber}/eligible
     * @secure
     */
    offerControllerGetEligible: (stockNumber: string, params: RequestParams = {}) =>
      this.request<OfferEligibleDto, void>({
        path: `/api/v1/buyer/offers/${stockNumber}/eligible`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Buyer API
     * @name OfferControllerUpdate
     * @request PATCH:/api/v1/buyer/offers/{stockNumber}/messages
     * @secure
     */
    offerControllerUpdate: (stockNumber: string, data: OfferMessageDto, params: RequestParams = {}) =>
      this.request<OfferDto, void>({
        path: `/api/v1/buyer/offers/${stockNumber}/messages`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions API
     * @name TransactionControllerGetTransactionRedirect
     * @request GET:/api/v1/transactions/{transactionId}/visit
     */
    transactionControllerGetTransactionRedirect: (
      transactionId: string,
      query: {
        /** Client name */
        client: string;
        /** JWT of the user */
        token: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/api/v1/transactions/${transactionId}/visit`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name OfferControllerGetSellerOffers
     * @request GET:/api/v1/seller/offers
     * @secure
     */
    offerControllerGetSellerOffers: (
      query?: {
        /** @default 1 */
        page?: number;
        /** @default 20 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<OfferCollectionDto, void>({
        path: `/api/v1/seller/offers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name DealControllerCreate
     * @request POST:/api/v1/seller/deals
     * @secure
     */
    dealControllerCreate: (data: CreateDealDto, params: RequestParams = {}) =>
      this.request<DealDto, ValidationErrorDto | void>({
        path: `/api/v1/seller/deals`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name DealControllerGetList
     * @request GET:/api/v1/seller/deals
     * @secure
     */
    dealControllerGetList: (
      query?: {
        /** @default 1 */
        page?: number;
        /** @default 20 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DealCollectionDto, void>({
        path: `/api/v1/seller/deals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name DealControllerGet
     * @request GET:/api/v1/seller/deals/{id}
     * @secure
     */
    dealControllerGet: (id: number, params: RequestParams = {}) =>
      this.request<DealDto, void>({
        path: `/api/v1/seller/deals/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name DealControllerUpdate
     * @request PATCH:/api/v1/seller/deals/{id}
     * @secure
     */
    dealControllerUpdate: (id: number, data: UpdateDealDto, params: RequestParams = {}) =>
      this.request<DealDto, ValidationErrorDto | void>({
        path: `/api/v1/seller/deals/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name DealControllerDelete
     * @request DELETE:/api/v1/seller/deals/{id}
     * @secure
     */
    dealControllerDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/v1/seller/deals/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name DealControllerGetByStockNumber
     * @request GET:/api/v1/seller/deals/by-stock-number/{stockNumber}
     * @secure
     */
    dealControllerGetByStockNumber: (stockNumber: string, params: RequestParams = {}) =>
      this.request<DealDto, void>({
        path: `/api/v1/seller/deals/by-stock-number/${stockNumber}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Health
     * @name HealthControllerGet
     * @request GET:/api/v1/health
     */
    healthControllerGet: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/health`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name DealOffersControllerGet
     * @request GET:/api/v1/seller/deals/{id}/offers
     * @secure
     */
    dealOffersControllerGet: (
      id: number,
      query?: {
        /** @default 1 */
        page?: number;
        /** @default 20 */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<OfferCollectionDto, void>({
        path: `/api/v1/seller/deals/${id}/offers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Seller API
     * @name DealOffersControllerCreate
     * @request PATCH:/api/v1/seller/offers/{id}/messages
     * @secure
     */
    dealOffersControllerCreate: (id: number, data: OfferMessageDto, params: RequestParams = {}) =>
      this.request<OfferDto, void>({
        path: `/api/v1/seller/offers/${id}/messages`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  webhook = {
    /**
     * No description
     *
     * @tags Webhooks API
     * @name OfferWebhookControllerGetTransactionRedirect
     * @request POST:/webhook/dr-chat
     */
    offerWebhookControllerGetTransactionRedirect: (data: OfferWebhook, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/webhook/dr-chat`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Webhooks API
     * @name OfferWebhookControllerHandleCaramelWebhook
     * @request POST:/webhook/caramel
     */
    offerWebhookControllerHandleCaramelWebhook: (data: CaramelWebhookDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/webhook/caramel`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
}
